import React from 'react'
import styled from 'styled-components'
import {useDispatch, useSelector} from "react-redux";
import {setSelectOnlyOneServiceAssembleModal} from "../../libs/action";

export default function DefaultServiceModal() {

    const dispatch = useDispatch()
    const {text} = useSelector((state) => state.estimateAdd.displayOnlyOneServiceAssembleModal)

    const onClickCloseLayerPopup = () => {
        dispatch(setSelectOnlyOneServiceAssembleModal({isOpen : false}))
    }

    return (
        <BackDrop>
            <WrapperLayer>
                <WrapperCloseIcon>
                    <CloseIcon className="icon-close btn-layer-pop_clse" onClick={onClickCloseLayerPopup}></CloseIcon>
                </WrapperCloseIcon>
                <WrapperTitleText dangerouslySetInnerHTML={{__html : text}}>
                </WrapperTitleText>
                <LayerButton onClick={onClickCloseLayerPopup}>
                    확인
                </LayerButton>
            </WrapperLayer>
        </BackDrop>
    )
}

const BackDrop = styled.div`
        height: 100%;
        left: 0;
        min-width: 950px;
        position: fixed;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 220;
        background-color: rgba(0, 0, 0, 0.75);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
`

const WrapperLayer = styled.div`
    &&{
        width: 342px;
        min-height: 215px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        padding: 14px 12px;
        box-sizing: border-box;
    }
`


const WrapperCloseIcon = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`


const CloseIcon = styled.button`
    font-size: 31px;
    color: #418DED;
    :hover {
        color: #005796;
    }
`

const WrapperTitleText = styled.div`
    width: 100%;
    font-weight: bold;
    font-size: 22px;
    margin-top: 15px;
    span {
        width: 100%;
        color: #333333;
        font-size: 22px;
        line-height: 28px;

        b {
            color: #3281ED;
        }
    }
`

const LayerButton = styled.button`
    && {
        width: 100px;
        height: 44px;
        background-color: #fff;
        border: 2px solid #418DED;
        color: #418DED;
        font-size: 16px;
        font-weight: bold;
        margin-top: 21px;
        :hover {
            background-color: #F6F6F6;
        }
    }
`




// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/defaultServiceModal.js